"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _MapContentPositioner = _interopRequireDefault(require("./util/MapContentPositioner"));

var _MapMarkerPositioner = _interopRequireDefault(require("./util/MapMarkerPositioner"));

var _ZillowMapContext = _interopRequireDefault(require("./ZillowMapContext"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/ZillowMapLayer.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var canUseDOM = typeof window !== 'undefined';

var ZillowMapLayer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ZillowMapLayer, _Component);

  function ZillowMapLayer(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      /**
       * The OverlayView created by the google maps library
       * https://developers.google.com/maps/documentation/javascript/customoverlays
       */
      overlayView: null,

      /**
       * Incremented when we want to redraw based on interaction with the google map
       * This is used to force updates on both this component and MapContentPositioner
       */
      updateCount: 0
    };
    _this.layerContainerDiv = null;
    _this.lastZeroPixel = null;
    _this.lastWorldWidth = 0;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  } // Components that render dynamically in response to user actions require componentDidMount and componentDidUpdate.
  // For components rendered on the server exclusively, update is sufficient.


  var _proto = ZillowMapLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var shouldInitializeOverview = canUseDOM && !(0, _isEmpty2.default)(window.google) && (0, _isEmpty2.default)(this.state.overlayView);

    if (shouldInitializeOverview) {
      this.initializeOverlayView();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var shouldInitializeOverview = canUseDOM && !(0, _isEmpty2.default)(window.google) && (0, _isEmpty2.default)(this.state.overlayView);

    if (shouldInitializeOverview) {
      this.initializeOverlayView();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var overlayView = this.state.overlayView;

    if (overlayView) {
      overlayView.setMap(null);
      overlayView.onAdd = null;
      overlayView.draw = null;
      overlayView.onRemove = null;
    }
  }
  /**
   * OnAdd is called by the Overlay View once after setMap is called to initialize the overlay
   * DOM elements.
   * https://developers.google.com/maps/documentation/javascript/reference/overlay-view#OverlayView.onAdd
   */
  ;

  _proto.onAdd = function onAdd() {
    var overlayView = this.state.overlayView;

    if (overlayView === null) {
      return null;
    }

    this.layerContainerDiv = document.createElement('div');
    this.layerContainerDiv.style.borderStyle = 'none';
    this.layerContainerDiv.style.borderWidth = '0px';
    this.layerContainerDiv.style.position = 'absolute';
    var mapPanes = overlayView.getPanes();
    mapPanes.overlayMouseTarget.appendChild(this.layerContainerDiv);
    return null;
  }
  /**
   * OnRemove is called by the Overlay View once after setMap is called with null. Used to
   * clean up the DOM of any overlay elements.
   * https://developers.google.com/maps/documentation/javascript/reference/overlay-view#OverlayView.onRemove
   */
  ;

  _proto.onRemove = function onRemove() {
    if (this.layerContainerDiv) {
      this.layerContainerDiv.parentNode.removeChild(this.layerContainerDiv);
      this.layerContainerDiv = null;
    }
  }
  /**
   * Draw is called by the Overlay View every time the map is updated and needs to redraw
   * We increment a state counter in here to force the component and its children to re-render.
   *
   * The zoomHasChanged and mapHasSettled checks are a hack to catch if the user has finished a
   * pan or zoomed at all. We do this because the map doesn't fire the onZoomChanged or dragend
   * events until after the projection has been updated. So if we rely on the map events there
   * will be issues where we don't force a re-render quickly enough and positioned elements will
   * appear to be positioned incorrectly.
   *
   * By checking the projection ourselves we circumvent the issue and can also reduce the number
   * of render calls which improves performance when panning.
   */
  ;

  _proto.draw = function draw() {
    var overlayView = this.state.overlayView;

    if (overlayView === null) {
      return null;
    }

    var overlayProjection = overlayView.getProjection(); // Get the number of pixels across the whole world at the current zoom.
    // if zoom changes, this changes

    var worldWidth = overlayProjection.getWorldWidth(); // Ge the pixel value of latitude zero, longitude zero.

    var zeroLatLng = new google.maps.LatLng({
      lat: 0,
      lng: 0
    });
    var zeroPixel = overlayProjection.fromLatLngToDivPixel(zeroLatLng); // If the map and the markers ar not more than a pixel off
    // the user isn't going to be able to tell, so don't spend CPU resources rendering.
    // In testing, there was also a lot of floating point error causing false positives for zoom changed.

    var MAXIMUM_PIXEL_MISALIGN = 2;
    var zoomHasChanged = Math.abs(worldWidth - this.lastWorldWidth) > MAXIMUM_PIXEL_MISALIGN; // While we are dragging the map, the projection of the map doesn't change so the pixel
    // value of the 0,0 LatLng point will remain the same. Once we release the map, the
    // projection updates, which means the pixel value of the 0,0 LatLng point will be different
    // which indicates that we want to re-render.

    var mapProjectionHasRebased = !zeroPixel.equals(this.lastZeroPixel);
    var isFirstDraw = this.lastZeroPixel === null && this.lastWorldWidth === 0;

    if (zoomHasChanged) {
      this.props.onZoomChangeCallback(isFirstDraw);
    }

    if (mapProjectionHasRebased) {
      this.props.onMapProjectionRebase(isFirstDraw);
    }

    if (zoomHasChanged || mapProjectionHasRebased) {
      this.lastZeroPixel = zeroPixel;
      this.lastWorldWidth = worldWidth; // Rather than using forceUpdate() We increment a counter and pass it down to the
      // MapContentPositioner. By doing so we can have MapContentPositioner be a pure
      // component which will reduce the number of re-renders.

      this.forceRender();
    }

    return null;
  };

  _proto.forceRender = function forceRender() {
    this.setState(function (prevState) {
      return {
        updateCount: prevState.updateCount + 1
      };
    });
  };

  _proto.initializeOverlayView = function initializeOverlayView() {
    var overlayView = new google.maps.OverlayView(); // The following three functions are required by google
    // https://developers.google.com/maps/documentation/javascript/customoverlays#add

    overlayView.onAdd = this.onAdd.bind(this);
    overlayView.draw = this.draw.bind(this);
    overlayView.onRemove = this.onRemove.bind(this);
    overlayView.setMap(this.props.gmap);
    this.setState({
      overlayView: overlayView
    });
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props = this.props,
        ariaHidden = _this$props.ariaHidden,
        ariaLabel = _this$props.ariaLabel,
        ariaRole = _this$props.ariaRole,
        mouseDisable = _this$props.mouseDisable,
        children = _this$props.children,
        markers = _this$props.markers,
        gmap = _this$props.gmap,
        styles = _this$props.styles;

    var mapLayerDivStyle = _objectSpread({}, styles);

    if (mouseDisable) {
      mapLayerDivStyle.pointerEvents = 'none';
    }

    return _react.default.createElement("div", {
      "aria-hidden": ariaHidden || null,
      "aria-label": ariaLabel,
      role: ariaRole,
      className: "zillow-map-layer",
      style: mapLayerDivStyle,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 210
      },
      __self: this
    }, _react.default.Children.count(children) > 0 && _react.default.createElement(_MapContentPositioner.default, {
      updateCount: this.state.updateCount,
      zoom: gmap.getZoom(),
      overlay: this.state.overlayView,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 212
      },
      __self: this
    }, children), markers && markers.length > 0 && _react.default.createElement(_MapMarkerPositioner.default, {
      updateCount: this.state.updateCount,
      zoom: gmap.getZoom(),
      overlay: this.state.overlayView,
      markers: markers,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 221
      },
      __self: this
    }));
  };

  _proto.render = function render() {
    if ((0, _isEmpty2.default)(this.state.overlayView) || this.layerContainerDiv === null) {
      return null;
    }

    return _reactDom.default.createPortal(this.renderChildren(), this.layerContainerDiv);
  };

  return ZillowMapLayer;
}(_react.Component);

var mapContextToProps = function mapContextToProps(props) {
  return _react.default.createElement(_ZillowMapContext.default.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 245
    },
    __self: this
  }, function (contextData) {
    if (contextData.gmap) {
      return _react.default.createElement(ZillowMapLayer, _extends({}, props, contextData, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 249
        },
        __self: this
      }));
    }

    return null;
  });
};

ZillowMapLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  ariaLabel: _propTypes.default.string,
  ariaRole: _propTypes.default.string,
  ariaHidden: _propTypes.default.bool,
  gmap: _propTypes.default.shape({}).isRequired,
  mouseDisable: _propTypes.default.bool,
  styles: _propTypes.default.shape({}),

  /**
   * Called when we detect any sort of zoom change in the draw method. Used so components
   * using the ZillowMapLayer can have more reliable and up to date information about the
   * zoom state of the map.
   */
  onZoomChangeCallback: _propTypes.default.func,
  onMapProjectionRebase: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  markers: _propTypes.default.arrayOf(_propTypes.default.shape({
    markerId: _propTypes.default.string,
    key: _propTypes.default.string,
    markerLabel: _propTypes.default.string,
    lowZoomLabel: _propTypes.default.string,
    alwaysShowLabel: _propTypes.default.bool,
    mapBubbleHTML: _propTypes.default.string,
    eastWestLng: _propTypes.default.number,
    northSouthLat: _propTypes.default.number,
    notificationHighlight: _propTypes.default.bool,
    isHovered: _propTypes.default.bool,
    onHoverStart: _propTypes.default.func,
    onMapMarkerMouseEnter: _propTypes.default.func,
    clearHoveredMarkerId: _propTypes.default.func,
    onMapMarkerMouseLeave: _propTypes.default.func,
    onMarkerClick: _propTypes.default.func,
    overText: _propTypes.default.string,
    statusType: _propTypes.default.string,
    showDot: _propTypes.default.bool,
    title: _propTypes.default.string,
    visited: _propTypes.default.bool,
    favorite: _propTypes.default.bool,
    zillowOwned: _propTypes.default.bool,
    isTouchInterfacePreferred: _propTypes.default.bool,
    detailUrl: _propTypes.default.string,
    isCommunityEdgeCase: _propTypes.default.bool,
    zpid: _propTypes.default.string,
    buildingId: _propTypes.default.string,
    latLong: _propTypes.default.object
  }))
} : {};
ZillowMapLayer.defaultProps = {
  ariaLabel: null,
  ariaRole: null,
  ariaHidden: false,
  mouseDisable: false,
  styles: {},
  onZoomChangeCallback: function onZoomChangeCallback() {},
  onMapProjectionRebase: function onMapProjectionRebase() {},
  children: [],
  markers: []
};
var _default = mapContextToProps;
exports.default = _default;